import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Button } from "react-bootstrap";
import "./EmptyState.css";
export default function EmptyState({
  title,
  description,
  actionLabel,
  onActionClick,
  actionClassName = ""
}) {
  useLanguage();
  return <div className="bb-empty-state">
      <h3 className="bb-empty-state__title">{t(title)}</h3>
      <p className="bb-empty-state__description">{t(description)}</p>

      {actionLabel ? <Button variant="primary" className={actionClassName} onClick={onActionClick}>
          {t(actionLabel)}
        </Button> : null}
    </div>;
}
